import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';

import type { TableModalType } from './types';
import { DescriptorsMap } from './constants';

export const createValidationSchema: FieldDescriptor<TableModalType>['createValidationSchema'] = (
  field
) => {
  const refines: [(input: unknown) => boolean, string][] = [];
  const optionalColumnKeys: string[] = [];
  const fieldColumnKeys: string[] = [];
  const columnsSchema = field.columns.reduce((acc, column) => {
    const descriptor = DescriptorsMap[column.type];
    if (!descriptor?.createValidationSchema) {
      return acc;
    }

    // @ts-expect-error typescript can't infer the type of column and descriptor
    const result = descriptor.createValidationSchema(column);
    if (!result) {
      return acc;
    }

    const { schema: cellSchema, refines: cellRefines = [] } = result;
    if (!cellSchema) {
      return acc;
    }

    fieldColumnKeys.push(column.key);
    acc[column.key] = cellSchema;
    refines.push(...cellRefines);

    if ('validation' in column && column.validation.isOptional) {
      optionalColumnKeys.push(column.key);
      acc[column.key] = acc[column.key].optional();
    }

    return acc;
  }, {});

  if (Object.keys(columnsSchema).length === 0) {
    return;
  }

  const schemaObject = field.data.reduce((acc, row) => {
    acc[row.key] = z.object(columnsSchema);

    if (optionalColumnKeys.length === fieldColumnKeys.length) {
      acc[row.key] = acc[row.key].optional();
    }
    return acc;
  }, {});

  let finalSchema: ZodTypeAny = z.object(schemaObject);

  if (field.validation?.isOptional) {
    finalSchema = finalSchema.optional();
  }

  refines.forEach((refineFn) => {
    finalSchema = finalSchema.refine(...refineFn);
  });

  return finalSchema;
};
